import React, { useState } from "react";
import AddSession from "./AddSession";
const CreateLearningSession = () => {
  // const [data, setData] = useState([<AddSession />]);

  // const singleInput = <AddSession />;

  // const handleAddClick = () => {
  //   setData([...data, singleInput]);
  // };

  return (
    <>
      <div className="text-light border border-warning rounded-3 d-flex justify-content-center p-2 my-3">
        <div className="faTrophy">
          <i className="fa-solid fa-calendar-plus"></i>
        </div>
        <h4 className="mx-3 text-warning p-2">Create Learning Session</h4>
      </div>

      {/* {data.map((single, i) => {
        return ( */}
      <div>
        <AddSession />
      </div>
      {/* );
      })} */}
    </>
  );
};

export default CreateLearningSession;
